import {
  setStorageWithExpiry
} from 'helpers';

export function cleanResponse(response) {
  return {
    ok: true,
    status: response.status,
    result: response.data?.result || response.data,
    trace: null,
    date: null,
    code: null,
    stamp: new Date()
  };
}

export const handleNoAuth = (error, func) => {

  if (error?.response?.status !== 401) {
    return;
  }

  setStorageWithExpiry('Auth', 'token', null);
  func();

  return;
};

export const onVouchersNoAuth = (error) => {

  handleNoAuth(error, () => {
    window.location.pathname = '/voucher-advance';
  });

  return;
};
